import React, { useEffect, useState } from "react";
import { Textbox } from "../../global/components/inputs/textbox/textbox";
import { IEpiProps, SearchContext } from "../models/vertex-search-page-models";
import { useVertexSearchContext, useVertexSearchDispatch } from "../reducers/vertex-search-page-provider";

interface IProps {
    onSearchContextClick: (searchContext: string) => void;
}

interface IContextProps {
    epiProps: IEpiProps
    currentSearchContext: string
}

export const SearchContextSelection = (props: IProps) => {
    const { epiProps, currentSearchContext }: IContextProps = useVertexSearchContext();
    const dispatch = useVertexSearchDispatch();
    const [showAdvancedSearchTooltip, setShowAdvancedSearchTooltip] = useState(false);

    function onAdvancedSearchTooltipClick() {
        setShowAdvancedSearchTooltip(true);
    }
    useEffect(() => {
        window.Tooltips();
    }, []);


    return (
        <div className="search-page-sort">
            <div className="search-page-sort-inner">
                <button className={`search-page-sort-button ${currentSearchContext == SearchContext.AllAAP ? "search-page-sort-button-active" : ""}`} onClick={() => props.onSearchContextClick(SearchContext.AllAAP)}>
                      <span>{epiProps.allAAPContextText}</span>
                </button>
                <button className={`search-page-sort-button ${currentSearchContext == SearchContext.ShopAAP ? "search-page-sort-button-active" : ""}`} onClick={() => props.onSearchContextClick(SearchContext.ShopAAP)}>
                       <span>{epiProps.shopAAPContextText}</span>
                </button>
                <button className={`search-page-sort-button ${currentSearchContext == SearchContext.HealthyChildren ? "search-page-sort-button-active" : ""}`} onClick={() => props.onSearchContextClick(SearchContext.HealthyChildren)}>
                   <span>{epiProps.healthyChildrenContextText}</span>
                </button>
            </div>
            <div className="vertex-search-advanced-tips">
                <p>{epiProps.advancedSearchTipsTooltipLabelText}</p>
            <div className="aap-tooltip  click-only" data-tooltip>
                <button className="un-button aap-tooltip-info-trigger" type="button" data-tooltip-trigger="" aria-expanded="false" aria-label="">
                    <svg className="svg-icon"> <use xlinkHref="#icon-information" /> </svg>
                </button>
                <div className="tooltip-region" role="region" aria-hidden="true" data-tooltip-region="">
                    <button className="tooltip-close" type="button" data-tooltip-close=""></button>
                    <span dangerouslySetInnerHTML={{ __html: epiProps.advancedSearchTipsTooltipText }}></span>
                </div>
                </div>
            </div>
        </div>
    )
}